import { Repository } from './common/repository.class'
import { RepositoryStrategyEnum } from 'src/shared/enum/repository-strategy.enum'
import { provideMockedPrograms } from '../datasource/mock/program.mock'
import { IProgram } from '@shared/interface/model.interface'
import { apiGetPrograms, apiPutProgram } from '../datasource/remote/program.api'
import { dbGetPrograms, dbSetPrograms, dbUpdateProgramComment } from '../datasource/local/program.database'
import { ApiError } from '@shared/error/api.error'
import { IApiResponse } from '@shared/interface/api-response.interface'
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

class ProgramRepository extends Repository {
  constructor() {
    super()
  }

  /*****************************************
  *
  * GET FUNCTIONS
  *
  *****************************************/
  // Get current user's devices
  getPrograms(forcedStrategy?: RepositoryStrategyEnum): Promise<IProgram[]> {
    const finalStrategy = forcedStrategy != null ? forcedStrategy : this.repositoryStragtegy

    if (finalStrategy === RepositoryStrategyEnum.MOCK) {
      return Promise.resolve(provideMockedPrograms())
    } else {
      if (finalStrategy === RepositoryStrategyEnum.LOCAL_FIRST) {
        return dbGetPrograms().then(programs => {
          if (programs.length === 0) {
            return apiGetPrograms().then(progs => {
              dbSetPrograms(progs)
              return progs
            })
          } else {
            apiGetPrograms().then(progs => dbSetPrograms(progs))

            return programs
          }
        })
      } else if (finalStrategy === RepositoryStrategyEnum.LOCAL_ONLY) {
        return dbGetPrograms()
      } else {
        return apiGetPrograms()
          .then(progs => {
            dbSetPrograms(progs)
            return progs
          })
          .catch(() => dbGetPrograms())
      }
    }
  }

  /*****************************************
  *
  * PUT FUNCTIONS
  *
  *****************************************/
  // Update program (only comment)
  putProgram(program?: IProgram): Promise<IApiResponse<string, string> | undefined> {
    if (sessionManager.isOnline.value && program != null) {
      return apiPutProgram(program)
        .then((response: IApiResponse<string, string> | undefined) => {
          dbUpdateProgramComment(program)
          return response
        })
        .catch((err: ErrorConstructor) => {
          if (err instanceof ApiError) {
            if (err.code === 'PRG_UPDATE_ERR_01') {
              throw new Error('Programme inconnu')
            } else if (err.code === 'PRG_UPDATE_ERR_02') {
              throw new Error('Utilisateur inconnu')
            } else if (err.code === 'PRG_UPDATE_ERR_03') {
              throw new Error('Droits insuffisants')
            } else if (err.code === 'PRG_UPDATE_ERR_04') {
              throw new Error('Commentaire non valide')
            } else if (err.code === 'PRG_UPDATE_ERR_05') {
              throw new Error('Erreur technique lors de la mise à jour du programme')
            }
          } else {
            throw new Error('Erreur inconnue')
          }
          return undefined
        })
    } else {
      return Promise.resolve(undefined)
    }
  }
}

export default new ProgramRepository()
